<template>
    <div>
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col md:w-1/4 w-full">
                    <label class="vs-input--label">{{ $t('multipleChoice.category') }}</label>
                    <vs-input class="w-full" v-model="selectCategory" type="text" data-vv-validate-on="blur" />
                </div>
                <div class="vx-col md:w-1/4 w-full">
                    <label class="vs-input--label">{{ $t('multipleChoice.subject') }}</label>
                    <vs-input class="w-full" v-model="selectSubject" type="text" data-vv-validate-on="blur" />
                </div>
                <div class="vx-col md:w-1/4 w-full">
                    <label class="vs-input--label">{{ $t('multipleChoice.grade') }}</label>
                    <!--                    <v-select class="" :clearable="false" v-model="selectGrade" :options="gradeOptions"-->
                    <!--                        :reduce="(option) => option.label">-->
                    <!--                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>-->
                    <!--                    </v-select>-->
                    <vs-input class="w-full" v-model="selectGrade" type="text" data-vv-validate-on="blur" />
                </div>
                <vs-button icon="icon-search" icon-pack="feather" color="primary" class="mt-6 ml-4" @click="filter">{{
                        $t('multipleChoice.search') }}</vs-button>
                <vs-button icon="icon-plus" icon-pack="feather" color="primary" class="mt-6 ml-4" @click="openPopup">
                    {{ $t('multipleChoice.button_add') }}
                </vs-button>
            </div>
        </div>
        <div>
            <vs-popup :title="$t('multipleChoice.button_add')" :active.sync="popupActiveUse">
                <div class="vx-row">
                    <div class="vx-col md:w-full">
                        <label class="vs-input--label required">{{ $t('multipleChoice.category') }}</label>
                        <vs-input class="w-full" v-model="category.categoryName" type="text" data-vv-validate-on="blur"
                            v-validate="'required'" name="category" />
                        <span class="text-danger text-sm">{{ errors.first('category') }}</span>
                    </div>
                </div>
                <div class="vx-row mt-2">
                    <div class="vx-col md:w-full">
                        <label class="vs-input--label required">{{ $t('multipleChoice.subject') }}</label>
                        <vs-input class="w-full" v-model="category.subject" type="text" data-vv-validate-on="blur"
                            v-validate="'required'" name="subject" />
                        <span class="text-danger text-sm">{{ errors.first('subject') }}</span>
                    </div>
                </div>
                <div class="vx-row mt-2">
                    <div class="vx-col md:w-full">
                        <label class="vs-input--label required">{{ $t('multipleChoice.grade') }}</label>
                        <vs-input class="w-full" v-model="category.grade" type="text" data-vv-validate-on="blur"
                            v-validate="'required'" name="grade" />
                        <span class="text-danger text-sm">{{ errors.first('grade') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full flex flex-wrap mt-4">
                        <div class="flex justify-center upload">
                            <div class="file-upload" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                                <input ref="file" type="file" id="imageUpload" multiple class="hidden"
                                    @change="uploadFile()">
                                <div class="mx-auto">
                                    <div class="text-center">
                                        <feather-icon icon="UploadCloudIcon" svgClasses="h-10 w-10 text-primary" />
                                    </div>
                                    <div class="text-center button-upload">
                                        <vs-button @click="$refs.file.click()">{{ $t('multipleChoice.upload')
                                            }}</vs-button>
                                    </div>
                                    <div class="text-center mt-4">
                                        <label class="file-label text-primary">
                                            <div v-if="isDragging">{{ $t('multipleChoice.isDragging') }}</div>
                                            <div v-else>{{ $t('multipleChoice.outDragging') }}</div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-files mt-2 ml-8">
                            <vs-table stripe :pagination="files.length > 0" maxItems="4" :data="files"
                                noDataText="Không có dữ liệu">
                                <template slot="thead">
                                    <vs-th>
                                        {{ $t('multipleChoice.name') }}
                                    </vs-th>
                               
                                </template>

                                <template >
                                    <vs-tr >
                                        <vs-td class="text-primary">
                                            {{ files.name }}
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </div>
                </div>
                <div class="vx-row mt-2">
                    <div class="vx-col w-full mt-2">
                        <div class="mt-2 flex flex-wrap items-center justify-end mb-2">
                            <vs-button class="float-right mr-5" @click="saveCategory">{{ $t('multipleChoice.button_add')
                                }}</vs-button>
                        </div>
                    </div>
                </div>
            </vs-popup>
            <div class="vx-card mt-2">
                <div class="vx-col w-full">
                    <ag-grid-vue style="height: 55vh" ref="agGridTable"
                        class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                        :defaultColDef="defaultColDef" :rowData="dataCategory" :animateRows="true"
                        :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }" @grid-ready="onGridReady"
                        :autoSizeStrategy="autoSizeStrategy">
                    </ag-grid-vue>
                    <div class="vx-row mt-8" v-if="totalElements > 0">
                        <div style="min-width:200px" class="vx-col md:w-1/2 w-full ">
                            <span class="content-page font-bold ml-6">{{ $t('dashboard.display') }}: </span>
                            <span class="text-page">
                                {{ countElementPage > totalElements ? totalElements : countElementPage }} / {{
                                totalElements }}
                            </span>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                            <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select';
import Pagination from "../../ui-elements/Pagination.vue";
import { AgGridVue } from "ag-grid-vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import moment from "moment";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import { ModuleRegistry } from '@ag-grid-community/core';
ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    components: {
        vSelect,
        Pagination,
        AgGridVue,
        CellRendererActions
    },
    data() {
        return {
            popupActiveUse: false,
            gridApi: null,
            category: {
                categoryName: null,
                subject: null,
                grade: null,
                fileId: null,
            },
            files: [],
            selectCategory: null,
            selectSubject: null,
            selectGrade: null,
            categoryOptions: [
            ],
            subjectOptions: [
                { label: 'Không xác định', value: null },
                { label: 'Môn học 1', value: 0 },
                { label: 'Môn học 2', value: 1 }
            ],
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('multipleChoice.stt'),
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: this.$t('multipleChoice.category'),
                    field: 'categoryName',
                    width: 250,
                },
                {
                    headerName: this.$t('multipleChoice.subject'),
                    field: 'subject',
                    width: 250
                },
                {
                    headerName: this.$t('multipleChoice.grade'),
                    field: 'grade',
                    width: 100
                },
                {
                    headerName: this.$t('menuOrganization.createdDate'),
                    field: 'createdDate',
                    width: 250
                },
                {
                    headerName: this.$t('multipleChoice.updatedDate'),
                    field: 'modifiedDate',
                    width: 250
                },
                {
                    headerName: this.$t('multipleChoice.actions'),
                    field: 'actions',
                    width: 140,
                    cellRenderer: 'CellRendererActions',
                    suppressSizeToFit: true,
                },
            ],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            pageNumber: 0,
            pageSize: 20,
            totalPages: 0,
            countElementPage: 0,
            totalElements: 0,
            currentPage: 1,
            dataCategory: null,
            idCategory: null,
            filesId: [],
            isDragging: false,
        }
    },
    created() {
        this.getCategory();
        this.filter();
    },
    methods: {
        dragover(e) {
            e.preventDefault()
            this.isDragging = true
        },
        dragleave() {
            this.isDragging = false
        },
        drop(e) {
            e.preventDefault()
            this.$refs.file.files = e.dataTransfer.files
            this.uploadFile()
            this.isDragging = false
        },

        uploadFile() {
            let file = this.$refs.file.files[0]
            this.files = file;
            this.$refs.file.value = null
        },

        confirmDeleteRecord(indextr) {
            this.files.splice(indextr, 1)
        },
        openPopup() {
            this.category.categoryName = null;
            this.category.subject = null;
            this.category.grade = null;
            this.popupActiveUse = true;
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },
        handleClickUploadFile() {
            return new Promise((resolve) => {
                let formData = new FormData(), config = {};
                    formData.append('files', this.files);
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                };

                this.$vs.loading();
                let url = `/school-quiz-category/upload-file-category`
                this.$crm.post(url, formData, config).then((res) => {
                    this.filesId = [];
                    res.data.fileManager.map(el => {
                        this.filesId.push(el.id)
                    });
                    resolve(true);
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            });
        },

        getCategory() {
            let body = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                categoryName: this.selectCategory ? this.selectCategory : null,
                subject: this.selectSubject ? this.selectSubject : null,
                grade: this.selectGrade !== "Tất cả" ? this.selectGrade : null

            }
            this.$vs.loading();
            this.$crm.post('/school-quiz-category/find-by-condition', body).then((response) => {
                this.categoryOptions = response.data.content.map(el => {
                    return {
                        label: el.categoryName,
                        value: el.id
                    }
                })
                this.dataCategory = response.data.content.map(el => {
                    el.stt = response.data.content.indexOf(el) + 1;
                    el.createdDate = el.createdDate ? moment(el.createdDate).format('DD/MM/YYYY HH:mm') : '';
                    el.modifiedDate = el.modifiedDate ? moment(el.modifiedDate).format('DD/MM/YYYY HH:mm') : '';
                    return el;
                })
                this.categoryOptions.unshift({ label: this.$t('multipleChoice.all'), value: null })
                this.countElementPage = this.dataCategory.length;
                this.totalElements = response.data.totalElements;
                this.totalPages = response.data.totalPages
                this.$vs.loading.close();
            })
        },
        async saveCategory(evt) {
            // evt.preventDefault();
            // if (!this.validateForm) return;
            // const result = this.$validator.validateAll();
            // if (!result) return;
            if (!this.category.categoryName || !this.category.subject || !this.category.grade) {
                return this.$vs.notify({
                    text: this.$t('multipleChoice.notice_field'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning',
                })
            }
            if (this.files) {
                await this.handleClickUploadFile();
            }
            this.category.fileId = this.filesId
            this.$vs.loading();
            this.$crm.post('/school-quiz-category/create', this.category).then((response) => {
                this.$vs.loading.close();
                this.popupActiveUse = false;
                this.getCategory();
                return this.$vs.notify({
                    text: this.$t('multipleChoice.create_success'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success',
                });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },


        filter() {
            this.getCategory()
        },
        loadPage: function (currentPage) {
            if (parseInt(currentPage) - 1 != this.pageNumber) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getCategory();
            }
        },
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },
    watch: {
        '$store.state.isDeleteCategory'(val) {
            if (val) {
                this.getCategory();
                this.$store.commit('DELETE_CATEGORY', false);
            }
        },
    },
}
</script>
<style scoped>
.required::after {
    content: '* ';
    color: red;
}
</style>
<style lang="scss">
.upload {
    .file-upload {
        width: 150px;
        height: 150px;
        border: dashed 2px rgba(var(--vs-primary), 1);
        border-radius: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: center;

        .button-upload button {
            border-radius: 1.5rem;
        }

        .file-label {
            color: #C0C0C0;
        }
    }
}

.table-files {
    width: calc(100% - 210px);

    .vs-table--tbody,
    .vs-table--thead {
        position: static;
    }

    .vs-pagination--buttons {
        z-index: 0;
    }
}
</style>
